var map = {
	"./el/blogs.json": [
		54624,
		4624
	],
	"./el/docs.json": [
		31512,
		1512
	],
	"./el/legals.json": [
		77345,
		7345
	],
	"./el/translation.json": [
		89168,
		9168
	],
	"./en-US/blogs.json": [
		58764,
		8764
	],
	"./en-US/docs.json": [
		6409,
		6409
	],
	"./en-US/legals.json": [
		39919,
		9919
	],
	"./en-US/translation.json": [
		28111,
		8111
	],
	"./es/blogs.json": [
		59373,
		9373
	],
	"./es/docs.json": [
		80141,
		141
	],
	"./es/legals.json": [
		962,
		962
	],
	"./es/translation.json": [
		10749,
		7576
	],
	"./ja/blogs.json": [
		12285,
		2285
	],
	"./ja/docs.json": [
		34460,
		4460
	],
	"./ja/legals.json": [
		12413,
		2413
	],
	"./ja/translation.json": [
		25906,
		5906
	],
	"./zh/blogs.json": [
		94889,
		4889
	],
	"./zh/docs.json": [
		38095,
		8095
	],
	"./zh/legals.json": [
		59070,
		9070
	],
	"./zh/translation.json": [
		73171,
		3171
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 7535;
module.exports = webpackAsyncContext;